import { render, staticRenderFns } from "./addTeamTeach.vue?vue&type=template&id=cf9a6330&scoped=true"
import script from "./addTeamTeach.vue?vue&type=script&lang=js"
export * from "./addTeamTeach.vue?vue&type=script&lang=js"
import style0 from "./addTeamTeach.vue?vue&type=style&index=0&id=cf9a6330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9a6330",
  null
  
)

export default component.exports